//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popover'
import 'devextreme/ui/scroll_view'
import 'devextreme/ui/progress_bar'

//#endregion

import { ALARM_DEFINITION_SERVICE_NAME } from '../../../../../../services/alarm-definition'
import { AlarmDefinitionsBulkEditController } from './alarm-definitions-bulk-edit.controller'
import { GRID_SERVICE_NAME } from '../../../../../../services/grid'
import { REFERENCE_TYPE_SERVICE_NAME } from '../../../../../../services/reference-type'
import { USER_SESSION_SERVICE_NAME } from '../../../../../../services/user-session'
import { $SCOPE_SERVICE_NAME } from '../../../../../../services/system'

//#region Asset Imports

import './alarm-definitions-bulk-edit.scss'
import * as TEMPLATE from './alarm-definitions-bulk-edit.tpl.html'

//#endregion

// #region Consts
export const COMPONENT_NAME: string = 'alarmDefinitionsBulkEdit'

// #endregion

export class AlarmDefinitionsBulkEditComponent implements ng.IComponentOptions {
    controller = [
        $SCOPE_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        ALARM_DEFINITION_SERVICE_NAME,
        GRID_SERVICE_NAME,
        REFERENCE_TYPE_SERVICE_NAME,
        AlarmDefinitionsBulkEditController
    ]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE
}
